import NavMenuSidebar from "./nav-menu-sidebar";

const HeaderNav = {
  _selectors: {
    headerNav: ".js-header-nav",
    menu: ".js-nav-menu",
    menuItemTopLevel: ".js-nav-menu-item-top-level",
    dropdownContainer: ".js-nav-menu-dropdown",
  },

  init() {
    const self = this;

    // No menu created yet
    if (document.querySelector(this._selectors.headerNav) === null) {
      return false;
    }

    document
      .querySelector(this._selectors.menu)
      .querySelectorAll(this._selectors.menuItemTopLevel)
      .forEach((node) => {
        if (node.hasAttribute("data-has-children")) {
          node.addEventListener("mouseenter", this.onMenuShow.bind(this));
          node.addEventListener("mouseleave", this.onMenuHide.bind(this));
        }

        if (!node.hasAttribute("data-mega-menu")) {
          node.addEventListener("mouseenter", this.onNavItemEnter.bind(this));
          node.addEventListener("mouseleave", this.onNavItemLeave.bind(this));
        }

        if (node.hasAttribute("data-mega-menu")) {
          node.addEventListener(
            "mouseenter",
            this.onMegaMenuItemEnter.bind(this)
          );
          node.addEventListener(
            "mouseleave",
            this.onMegaMenuItemLeave.bind(this)
          );
        }
      });

    // Initialises sidebar menu
    NavMenuSidebar.init();
  },

  onNavItemEnter() {
    document
      .querySelector(this._selectors.headerNav)
      .classList.add("nav-active");
  },

  onNavItemLeave() {
    document
      .querySelector(this._selectors.headerNav)
      .classList.remove("nav-active");
  },

  onMenuShow() {
    document
      .querySelector(this._selectors.headerNav)
      .classList.add("show-overlay");
  },

  onMenuHide() {
    document
      .querySelector(this._selectors.headerNav)
      .classList.remove("show-overlay");
  },

  onMegaMenuItemEnter(e) {
    const dropdownEl = e.currentTarget.querySelector(
      this._selectors.dropdownContainer
    );
    if (this.isDropdownScrollRequired(dropdownEl)) {
      dropdownEl.style.overflow = "auto";
      dropdownEl.style.height =
        window.innerHeight - dropdownEl.offsetTop + "px";
    } else {
      dropdownEl.style.overflow = "hidden";
      dropdownEl.style.height = "auto";
    }
  },

  onMegaMenuItemLeave(e) {
    const dropdownEl = e.currentTarget.querySelector(
      this._selectors.dropdownContainer
    );
    dropdownEl.style.overflow = "hidden";
    dropdownEl.style.height = "auto";
  },

  isDropdownScrollRequired(dropdownEl) {
    const bottomPos = dropdownEl.offsetTop + dropdownEl.offsetHeight;
    return bottomPos > window.innerHeight;
  },

  getDefaultColourTheme() {
    let defaultTheme = document
      .querySelector(this._selectors.headerNav)
      .getAttribute("data-default-theme");

    if (defaultTheme === "" || defaultTheme === null) {
      defaultTheme = "green";
    }

    return defaultTheme;
  },
};

export default HeaderNav;
